//@flow

import React, { Component } from 'react';
import isEmail from 'validator/lib/isEmail';
import { connect } from 'react-redux';
import { Col, Button, FormGroup, Input, Label } from 'reactstrap';

import api from '../../lib/api';
import config from '../../config';
import Ratings from './Ratings';
import getAverage from './utils';

type Props = {
  userImageURI: string | null,
  addReview: (review: string) => void,
  openLoginModal: () => void,
  sendRatings: (ratings: Object | null) => void,
  ratingsTitles?: Array<String>,
  isSubmitted: boolean,
  isLoggedIn: boolean,
};

type State = {
  review: string,
  ratings: Object,
  errors: Object,
  loading: boolean,
  averageRating: number,
};

const initialState = {
  review: '',
  fullname: '',
  email: '',
  ratings: {},
  errors: {},
  loading: false,
  averageRating: 0,
};

const defaultImageAvatar = `${config.ASSETS_URL}/navbar_user_image.png`;

class ReviewForm extends Component<Props, State> {
  static defaultProps = {
    ratingsTitles: null,
    sendRatings: () => {},
  };

  state = { ...initialState };

  componentDidMount() {
    const { email, fullname } = this.props;

    this.setState({ email, fullname });
  }

  handleStateChange = e =>
    this.setState({
      [e.target.name]: e.target.value,
      errors: { [e.target.name]: '' },
    });

  handleReviews = e => this.setState({ review: e.target.value, errors: {} });

  handleRatings = (rating: number, title: string) => {
    this.setState(
      ({ ratings }) => ({
        ratings: { ...ratings, [title]: rating },
        errors: {},
      }),
      () => this.calculateAverageRatings()
    );
  };

  calculateAverageRatings = () =>
    this.setState(({ ratings }) => ({ averageRating: getAverage(ratings) }));

  onSubmit = e => {
    e.preventDefault();

    const { addReview, sendRatings, isLoggedIn } = this.props;
    const { review, ratings, fullname, email } = this.state;

    const errors = this.validate();
    this.setState({ errors });

    const noErrors = Object.keys(errors).length === 0;
    if (noErrors) {
      this.setState({ loading: true });
      if (isLoggedIn) {
        addReview(review);
        sendRatings(ratings);
      } else {
        api.get('users/guest').then(({ data }) => {
          addReview(review, { fullname, email, token: data.token });
          sendRatings(ratings, { fullname, email, token: data.token });
        });
      }
    }
  };

  validate = () => {
    const { ratings, review, email, fullname } = this.state;
    const { ratingsTitles } = this.props;

    const errors = {};

    const wordCount = 5;
    const starTypes = ratingsTitles && ratingsTitles.length;

    const userGaveAllRatings = Object.keys(ratings).length === starTypes;
    const userAddReviews = this.getWordCount((review: string)) > wordCount;
    const userIsGivingReview = Boolean(ratingsTitles);

    if (!userAddReviews) errors.reviews = 'Oops! there is something wrong!';
    if (!email || !isEmail(email)) errors.email = 'Please inform us your valid email';
    if (!fullname.trim()) errors.name = 'Please inform us your name';

    // since the same ReviewsForm is used when user give reviews and replies.
    // so when the user give reviews, ratings titles are always present
    if (userIsGivingReview && !userGaveAllRatings)
      errors.ratings = 'Oops! you`ve missed a rating';

    return errors;
  };

  /**
   * extract the length of the word for the reviews minus the white spaces
   */

  getWordCount = (str: string) =>
    str
      .split(' ')
      .filter(x => Boolean(x))
      .join('').length;

  componentDidUpdate(prevProps: Props) {
    const userReplied = Boolean(prevProps.isSubmitted);

    if (userReplied) this.setState({ ...initialState });
  }

  render() {
    const { review, errors, loading } = this.state;
    const { ratingsTitles, userImageURI } = this.props;

    const avatarImageURI = userImageURI || defaultImageAvatar;

    return (
      <div className="comment-form">
        <div className="u-image">
          <img src={avatarImageURI} alt="avatar" />
        </div>
        <div className="text-wrap">
          <div className="mt-1">
            {ratingsTitles && (
              <FormGroup row>
                {ratingsTitles.map(title => (
                  <Ratings title={title} key={title} onRate={this.handleRatings} />
                ))}
                <Col md="6" className="my-2">
                  {/* <p className="rate-q">&nbsp;</p> */}
                  <p className="error">{errors.ratings}</p>
                </Col>
              </FormGroup>
            )}
            <FormGroup row>
              <Col className="mt-2" xs="12" sm="6">
                <Label> Name</Label>
                <Input
                  name="fullname"
                  type="fullname"
                  value={this.state.fullname}
                  onChange={this.handleStateChange}
                  className="form-control"
                />
                <p className="error">{errors.name}</p>
              </Col>
              <Col className="mt-2" xs="12" sm="6">
                <Label>Email</Label>
                <Input
                  name="email"
                  type="email"
                  value={this.state.email}
                  onChange={this.handleStateChange}
                  className="form-control"
                />
                <p className="error">{errors.email}</p>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Col className="mt-3">
                <Input
                  type="textarea"
                  value={review}
                  onChange={this.handleReviews}
                  className="form-control"
                  placeholder="Write a review"
                  rows={7}
                />
                <p className="error">{errors.reviews}</p>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Col className="mt-2">
                <Button
                  className={loading ? 'btn-loading' : ''}
                  color="yellow"
                  type="submit"
                  onClick={this.onSubmit}
                >
                  Submit
                </Button>
              </Col>
            </FormGroup>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ user }) => ({
  email: user.email,
  fullname: user.name,
});

export default connect(mapStateToProps)(ReviewForm);



// WEBPACK FOOTER //
// ./src/components/ReviewsRatings/ReviewsForm.jsx